import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const AnimatedComponent = ({ children, animation }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={animation}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedComponent;
